import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import "firebase/compat/firestore";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCCjlueJFNVTdy1erAHJGos32NRT-mmavo",
  authDomain: "ayawaso-city-complaints-app.firebaseapp.com",
  projectId: "ayawaso-city-complaints-app",
  storageBucket: "ayawaso-city-complaints-app.appspot.com",
  messagingSenderId: "688239765837",
  appId: "1:688239765837:web:c49976ed8d897c0abeaf04",
  measurementId: "G-NH9QKD4D2P",
};

const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

export default db;
